import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef } from 'react';
var FlexibleTextArea = function FlexibleTextArea(props) {
  var _props$input, _props$input2;
  var textField = useRef(null);
  var _calculateSize = function _calculateSize() {
    if ((textField === null || textField === void 0 ? void 0 : textField.current) != null) {
      /**
       * @type {HTMLTextAreaElement} element
       */
      var element = textField.current;
      var rows = element.textContent.split('\n').length - 1;
      if (rows < 0) {
        rows = 0;
      }
      element.style.height = 63 + 23 * rows + "px";
    }
  };
  var _onBlur = function _onBlur() {
    if ((textField === null || textField === void 0 ? void 0 : textField.current) != null) {
      var element = textField.current;
      element.classList.remove('focus');
    }
    _calculateSize();

    // Animation timing
    setTimeout(function () {
      return _calculateSize();
    }, 150);
  };
  var _onFocus = function _onFocus() {
    if ((textField === null || textField === void 0 ? void 0 : textField.current) != null) {
      var element = textField.current;
      element.classList.add('focus');
    }
    _calculateSize();

    // Animation timing
    setTimeout(function () {
      return _calculateSize();
    }, 150);
  };
  useEffect(function () {
    _calculateSize();
  }, [props.children]);
  var elementProps = _objectSpread({}, props);
  delete elementProps.style;
  delete elementProps.children;
  delete elementProps.input;
  delete elementProps.meta;
  return /*#__PURE__*/React.createElement("textarea", _extends({
    className: "transition--fast",
    ref: textField,
    onKeyUp: _calculateSize,
    onBlur: _onBlur,
    onFocus: _onFocus,
    onChange: (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.onChange,
    value: (_props$input2 = props.input) === null || _props$input2 === void 0 ? void 0 : _props$input2.value,
    style: _objectSpread({
      resize: 'inherit',
      maxHeight: '109px'
    }, props.style)
  }, elementProps), props.children);
};
export default FlexibleTextArea;